
import { Navigate, Route, Routes } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import { useAuth } from '../context/AuthContext';
import PrivateRoute from '../context/PrivateRoute';
import ActivateAccount from '../pages/activateAccount/ActivateAccount';
import CustomCalendar from '../pages/calendar/CustomCalendar';
import { HigieneYCuidados } from '../pages/educative/HigieneYCuidados';
import MenstrualCycle from '../pages/educative/MenstrualCycle';
import MythsAndTruths from '../pages/educative/MythsAndTruths';
import Tips from '../pages/educative/Tips';
import Home from '../pages/home/Home';
import LandingPage from '../pages/landing/LandingPage';
import RegisterPage from '../pages/register/RegisterPage';
import TermsAndConditions from '../pages/termsAndConditions/TermsAndConditions';
import UserProfile from '../pages/UserProfile/UserProfile';
import { routes } from './routeConfig';


const AppRoutes = () => {
    const { isAuthenticated } = useAuth();
    return (
        <Routes>

            <Route
                path={routes.public.login}
                element={isAuthenticated ? <Navigate to={routes.private.home} replace /> : <LandingPage />}
            />
            <Route
                path={routes.public.register}
                element={isAuthenticated ? <Navigate to={routes.private.home} replace /> : <RegisterPage />}
            />
            <Route path={routes.public.terms} element={<TermsAndConditions />} />
            <Route path={routes.public.privacy} element={<TermsAndConditions />} />
            <Route
                path={routes.public.activateAccount}
                element={isAuthenticated ? <Navigate to={routes.private.home} replace /> : <ActivateAccount />}
            />


            {/* Rutas privadas con Dashboard como layout - rutas directas */}
            <Route
                element={
                    <PrivateRoute>
                        <Dashboard />
                    </PrivateRoute>
                }
            >
                {/* Rutas anidadas directas */}
                <Route path={routes.private.home} element={<Home />} />
                <Route path={routes.private.calendar} element={<CustomCalendar />} />
                <Route path={routes.private.userProfile} element={<UserProfile />} />
                <Route path={routes.private.knowYourCycle} element={<MenstrualCycle />} />
                <Route path={routes.private.higiene} element={<HigieneYCuidados />} />
                <Route path={routes.private.mythsAndTruths} element={<MythsAndTruths />} />
                <Route path={routes.private.tips} element={<Tips />} />
            </Route>

            {/* Redirección para rutas no encontradas */}
            <Route path='*' element={<Navigate to={routes.redirects.notFound} replace />} />
        </Routes>
    );
};

export default AppRoutes;